import React, { useState, useEffect, useRef } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { ResetPassword } from '../reduxactions/ResetPasswordActions';

const getPasswordMessage = (value: any): string => {
  if (typeof value === 'string') {
    return value;
  }

  if (Array.isArray(value)) {
    return value
      .map((item) => getPasswordMessage(item))
      .filter(Boolean)
      .join(' ');
  }

  if (value && typeof value === 'object') {
    return value.message || value.msg || value.status || '';
  }

  return '';
};


export const RestPass = () => {
  const uid = window.sessionStorage.getItem('uid');
  const dispatch = useDispatch();
  const password = useSelector((state: RootState) => state.resetpasswords.password);

  const [Opass, setOpass] = useState<any>('');
  const [Rpass, setRpass] = useState<any>('');
  const [Repass, setRepass] = useState<any>('');

  const msgs = useRef(null);
  useEffect(() => {
    const message = getPasswordMessage(password);
    if (message) {
      toast.current.show({ severity: 'info', summary: 'info', detail: message, life: 3000 })

    }

  }, [password]);

  const toast = useRef(password);
  const regsdata = async () => {
    try {
      await dispatch(ResetPassword(Opass, Rpass, Repass, uid) as any);

    } catch (error) {
      console.error('Error fetching data', error)
    }
    window.location.reload();

  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/fmresetpassword.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };

  return (
    <div className="admin-layout-container">

      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Reset Password</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>

            <section className="content">
              <div className="flex justify-content-center">
                <div
                  className="border-1 border-blue-500 border-round-xl shadow-3 p-5"
                  style={{ width: '50rem' }}
                >
                  <div className="mb-5">
                    <h2 className="m-0 text-center text-primary">
                      Change Password
                    </h2>
                  </div>

                  {/* Old Password */}
                  <div className="grid align-items-center mb-4">
                    <div className="col-12 md:col-4">
                      <label className="font-semibold text-900">
                        Old Password
                      </label>
                    </div>

                    <div className="col-12 md:col-8">
                      <InputText
                        type="password"
                        className="w-full"
                        placeholder='Enter Old Password'
                        name="oldpass"
                        onChange={(e) => setOpass(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* New Password */}
                  <div className="grid align-items-center mb-4">
                    <div className="col-12 md:col-4">
                      <label className="font-semibold text-900">
                        New Password
                      </label>
                    </div>

                    <div className="col-12 md:col-8">
                      <InputText
                        type="password"
                        className="w-full"
                        placeholder='Enter New Password'
                        name="newpass"
                        onChange={(e) => setRpass(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Confirm Password */}
                  <div className="grid align-items-center mb-5">
                    <div className="col-12 md:col-4">
                      <label className="font-semibold text-900">
                        Confirm New Password
                      </label>
                    </div>

                    <div className="col-12 md:col-8">
                      <InputText
                        type="password"
                        placeholder='Confirm New Password'
                        className="w-full"
                        name="repass"
                        onChange={(e) => setRepass(e.target.value)}
                      />
                    </div>
                  </div>

                  {/* Button */}
                  <div className="flex justify-content-center">
                    <Button
                      label="Update Password"
                      icon="pi pi-check"
                      className="px-5"
                      onClick={regsdata}
                      disabled={
                        Repass.trim() === '' ||
                        Rpass.trim() === '' ||
                        Opass.trim() === ''
                      }
                    />
                  </div>
                </div>
              </div>

              <Toast ref={toast} />
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
